import { RestModalAction } from '@bbk/retention-sdk/events/action-contracts';

export {
  type RestModalPerson,
  type RestModalForwardsModalEmail,
  type RestModalForwardsLink,
  type RestModalForwardsCancelWithLink,
  type RestModalForwardsNevermind,
  type RestModalForwardsAcceptOffer,
  type RestModalForwardsOfferConfirmation,
  type RestModalForwardsSendEmail,
  type RestModalForwardsDismissModal,
  type PauseOfferType,
  CtaProcessingOption,
  CheckoutLayout,
  CheckoutEligibilityRule,
  type CtaDetails,
  type RestModalForwards,
  type RestModalInfo,
  type RestModalPrice,
  type RestG2Rating,
  type RestQuote,
  type LossQuote,
  type LossActivity,
  type RestOfferCode,
  RestModalTemplates,
  type RestModalRequires,
  type RestAbstractModal,
  type OtherActionGenerics,
  type HeroImageV0,
  type HeroImageV1,
  type HeroImage,
  type HeroVideo,
  type HeroTwitter,
  type HeroQuote,
  type HeroQuotes,
  type RestSixtyFortyColumnModal,
  type RestLCOBanner,
  type RestLCOModal,
  type RestLCOPopUp,
  type RestOfferCardPack,
  type ModalContentSetItem,
  type RestSixtyFortyColumnActionModal,
  type RestSixtyFortyColumnCodeModal,
  type RestSixtyFortyColumnTwitterModal,
  type RestSixtyFortyColumnG2Modal,
  type RestFiftyFiftyColumnModal,
  type RestSeventyThirtyRowModal,
  type RestVideoRowModal,
  type RestSpeechBubble1Modal,
  type RestSpeechBubble2Modal,
  type RestFortySixtyMiniModal1Modal,
  type RestFortySixtyMiniModal2Modal,
  type RestAccountData,
  type RestFortySixtyMiniModal3Modal,
  type RestFortySixtyMiniModal4Modal,
  type RestModalEmailSendModal,
  type RestModalEmailStructuredModal,
  type RestModalEmailSuccessModal,
  type RestModalConfirmCancelModal,
  type RestModalFinalOffer,
  type RestModalMultiCTATypeI,
  type RestModalMultiCTATypeII,
  type RestRefundCancelModal,
  type RestModalCard,
} from '@bbk/retention-sdk/contracts/modal';

export {
  RestModalAction,
  type SyncConfig,
} from '@bbk/retention-sdk/events/action-contracts';

export const RestModalActionsAccepts = [
  RestModalAction.link,
  RestModalAction.accept_offer_with_confirmation,
  RestModalAction.modal_email,
  RestModalAction.modal_email_structured,
  RestModalAction.send_email,
];

export const RestModalActionCancels = [
  RestModalAction.cancel_with_link,
  RestModalAction.confirm_cancel,
];
export const RestModalActionOther = [
  ...RestModalActionCancels,
  RestModalAction.nevermind,
];

export const RestModalActionHumanString: Partial<
  Record<RestModalAction, string>
> = {
  [RestModalAction.modal_email]: 'Compose email',
  [RestModalAction.modal_email_structured]: 'Drilldown',
  [RestModalAction.send_email]: 'Send email',
  [RestModalAction.accept_offer]: 'Accept offer',
  [RestModalAction.accept_offer_with_confirmation]:
    'Accept, then show confirmation',
  [RestModalAction.open_offer_confirmation]: 'Confirm before accepting',
  [RestModalAction.link]: 'Link',
  [RestModalAction.cancel_with_link]: 'Cancel',
  [RestModalAction.confirm_cancel]: 'Confirm a cancel',
  [RestModalAction.show_code]: 'Show discount code',
  [RestModalAction.dismiss_modal]: 'Dismiss modal',
  [RestModalAction.nevermind]: 'Nevermind',
};

export enum RestModalTemplatesReadOnly {
  sixty_forty_column_action = 'sixty_forty_column_action',
  sixty_forty_column_code = 'sixty_forty_column_code',
  sixty_forty_column_twitter = 'sixty_forty_column_twitter',
  sixty_forty_column_g2 = 'sixty_forty_column_g2',
  fifty_fifty_column = 'fifty_fifty_column',
  seventy_thirty_row = 'seventy_thirty_row',
  speech_bubble_1 = 'speech_bubble_1',
  forty_sixty_mini_modal_3 = 'forty_sixty_mini_modal_3',
  forty_sixty_mini_modal_4 = 'forty_sixty_mini_modal_4',
  // Keep stored Intercom offers subject to the deprecated-template save restriction.
  intercom_chat_modal = 'intercom_chat_modal',
  multi_cta_type_I = 'multi_cta_type_I',
  multi_cta_type_II = 'multi_cta_type_II',
}
